import React from 'react'
import AccountsVirtualCards from 'src/app/AccountsVirtualCards/AccountsVirtualCards'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { accountsVirtualCardsRouteProps } from 'src/navigation/routeProps'

const AccountsVirtualCardsAppRoute: AppRoute = {
  routeProps: accountsVirtualCardsRouteProps,
  component: <AccountsVirtualCards />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountsVirtualCardsAppRoute
